import { render } from "./drawer.vue?vue&type=template&id=07176a32&scoped=true&ts=true"
import script from "./drawer.vue?vue&type=script&lang=ts"
export * from "./drawer.vue?vue&type=script&lang=ts"

import "./drawer.vue?vue&type=style&index=0&id=07176a32&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07176a32"]])

export default __exports__